import { render, staticRenderFns } from "./InvoiceDetailInternational.vue?vue&type=template&id=4bc48bda&scoped=true&"
import script from "./InvoiceDetailInternational.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailInternational.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailInternational.vue?vue&type=style&index=0&id=4bc48bda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc48bda",
  null
  
)

export default component.exports